import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Text } from '@leroy-merlin-br/backyard-react-ui'

const baseStyles = ({ theme }) => css`
  label: from-price;

  margin-bottom: ${theme.spacings.bit};
`

const blackWeekendStyles = ({ theme, isBlackWeekend }) =>
  isBlackWeekend &&
  css`
    label: from-price--black-weekend;

    color: ${theme.colors.white};
  `

export const FromPrice = styled(Text)(baseStyles, blackWeekendStyles)
